import React from 'react';

function NavTabs({ tabActiva, onCambiarTab }) {
  const tabs = [
    { id: 'stats',      icon: '📊', label: 'Dashboard' },
    { id: 'pedidos',    icon: '📦', label: 'Pedidos' },
    { id: 'catalogo',   icon: '🛍️', label: 'Catálogo' },
    { id: 'inventario', icon: '📋', label: 'Inventario' },
    { id: 'envio', icon: '🚚', label: 'Envío' },
    { id: 'variantes', icon: '🎨', label: 'Variantes' },
  ];

  return (
    <div style={styles.nav}>
      {tabs.map(tab => (
        <button
          key={tab.id}
          style={{
            ...styles.tab,
            color: tabActiva === tab.id ? '#128C7E' : '#7A8F89',
            borderBottom: tabActiva === tab.id ? '2.5px solid #25D366' : '2.5px solid transparent',
          }}
          onClick={() => onCambiarTab(tab.id)}
        >
          <span style={styles.icon}>{tab.icon}</span>
          {tab.label}
        </button>
      ))}
    </div>
  );
}

const styles = {
  nav: {
    display: 'flex',
    background: 'white',
    borderBottom: '1px solid #E4EDE8',
    position: 'sticky',
    top: 0,
    zIndex: 100,
    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
  },
  tab: {
    flex: 1,
    padding: '13px 0 11px',
    textAlign: 'center',
    fontSize: 11,
    fontWeight: 600,
    cursor: 'pointer',
    border: 'none',
    background: 'none',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 3,
    transition: 'color 0.18s',
  },
  icon: {
    fontSize: 18,
  },
};

export default NavTabs;